import { addClass, removeClass, hasClass } from "../util/misc"; // export default {

//   init() {
//     // JavaScript to be fired on all pages
//     faq();
//     console.log("i need this to work!");
//     console.log("if it doesnt we wont do anything");
//   },
//   finalize() {
//     // JavaScript to be fired on all pages, after page specific JS is fired
//   },
// };

export const faq = () => {
  const faqItems = document.querySelectorAll(".faq-item");
  if (faqItems.length < 1) return;
  faqItems.forEach((item) => {
    item.addEventListener("click", () => _toggleItem(item));
  });
};

const _toggleItem = (item) => {
  const answer = item.querySelector(".answer");
  const icon = item.querySelector(".icon");
  if (!answer || !icon) return;
  if (hasClass(answer, "hide-answer")) {
    removeClass(answer, "hide-answer");
    addClass(icon, "c-rotate");
  } else {
    addClass(answer, "hide-answer");
    removeClass(icon, "c-rotate");
  }
};



// WEBPACK FOOTER //
// ./scripts/sections/faq.js